<script setup lang="ts"></script>

<template>
  <div id="reset-email" class="reset-email">
    <NuxtLayout name="account">
      <NuxtLoadingIndicator />
      <LazyModulesResetEmailOrganismsWrapper />
    </NuxtLayout>
  </div>
</template>
